import React from 'react';
import PropTypes from 'prop-types';
import { isToday, isTomorrow } from 'date-fns';
import { defineMessages } from 'react-intl';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import Message from 'components/Message';
import './TodayTomorrowWeekday.scss';

const messages = defineMessages({
  today: {
    id: 'components.today-tomorrow-weekday.today',
    defaultMessage: 'today',
  },
  tomorrow: {
    id: 'components.today-tomorrow-weekday.tomorrow',
    defaultMessage: 'tomorrow',
  },
});

const TodayTomorrowWeekday = ({ date, className, lowercase }) => {
  const commonProps = {
    className: withMods('today-tomorrow-weekday', { lowercase }, className),
  };

  if (isToday(date)) {
    return <Message message={messages.today} {...commonProps} />;
  }

  if (isTomorrow(date)) {
    return <Message message={messages.tomorrow} {...commonProps} />;
  }

  return <Message format="dow" value={date} {...commonProps} />;
};

TodayTomorrowWeekday.propTypes = {
  date: PropTypes.instanceOf(Date),
  lowercase: PropTypes.bool,
  className: PropTypes.string,
};

export default TodayTomorrowWeekday;
